import Image from "next/image";

export default function BeanCounting() {
  return (
  <div className="overflow-hidden bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
        <div className="lg:ml-auto lg:pl-4 lg:pt-4">
          <div className="lg:max-w-lg">
            <p className="mt-2 text-3xl tracking-tight text-gray-900 sm:text-4xl">What&apos;s in a name?</p>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              The name &quot;Pinto&quot; is a nod to this ancient practice of bean counting.
            </p>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              Bean counting is an accounting practice that has been around for centuries. It refers to the use of beans to represent value or currency, and the beans were counted to keep track of transactions.
              This practice back to ancient civilizations, such as the Incas and the Aztecs, who used cocoa beans as currency.
            </p>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              We believe that the principles of simplicity, accuracy, and transparency that were essential to bean counting are still relevant today in the modern world of finance.
            </p>
          </div>
        </div>
        <div className="flex items-start justify-end lg:order-first">
          <Image
            src="/pinto-bean.webp"
            alt="Product screenshot"
            className="grayscale w-[36rem] max-w-none sm:w-[42em]"
            width={2432}
            height={1442}
            unoptimized
          />
        </div>
      </div>
    </div>
  </div>
  )
}
